export default {
  title: 'Fakturaer',
  form: {
    auto_generate_invoices: {
      label: 'Generer fakturaer automatisk',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
